import clsx from "clsx";

interface Props {
    className?: string
    FillColor?: string
}

export default function Facebook({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" className={clsx(className, FillColor)}>
            <path
                d="M7.744 12.587h1.974v8.123c0 .16.13.29.29.29h3.345c.16 0 .29-.13.29-.29v-8.085h2.269a.29.29 0 0 0 .288-.257l.345-2.99a.29.29 0 0 0-.289-.324h-2.612V7.179c0-.565.304-.851.904-.851h1.708c.16 0 .29-.13.29-.29V3.291a.29.29 0 0 0-.29-.29h-2.354c-.016 0-.053-.002-.108-.002-.408 0-1.828.08-2.95 1.112-1.242 1.143-1.07 2.512-1.028 2.75v2.192H7.744a.29.29 0 0 0-.29.29v2.952c0 .16.13.29.29.29z"/>
        </svg>
    )
}
